export default {
  FETCH_FORUM_EMAIL_TEMPLATES_REQUEST: 'FETCH_FORUM_EMAIL_TEMPLATES_REQUEST',
  FETCH_FORUM_EMAIL_TEMPLATES_SUCCESS: 'FETCH_FORUM_EMAIL_TEMPLATES_SUCCESS',
  FETCH_FORUM_EMAIL_TEMPLATES_FAILURE: 'FETCH_FORUM_EMAIL_TEMPLATES_FAILURE',
  UPDATE_FORUM_EMAIL_TEMPLATE: 'UPDATE_FORUM_EMAIL_TEMPLATE'
}
